import axios from '../../axios'

/*
 * 服务卡激活码数据接口
 */

// 服务卡激活码数据接口
export const wishUser = (data) => {
    return axios({
        url: '/api/admin/wish/user',
        method: 'post',
        data
    })
}

// editUser
export const editUser = (data) => {
    return axios({
        url: '/api/admin/wish/save_user',
        method: 'post',
        data
    })
}

// 保存设置限制时间
export const saveLimitDate = (data) => {
    return axios({
        url: '/api/base/save_limit_date',
        method: 'post',
        data
    })
}

// 获取设置限制开始时间
export const getLimitDate = (data) => {
    return axios({
        url: '/api/base/get_limit_date',
        method: 'get',
        data
    })
}

// 用户统计
export const stat = (data) => {
    return axios({
        url: '/api/data/wish/order/stat',
        method: 'post',
        data
    })
}

// 渠道用户完善率统计
export const channelStat = (data) => {
    return axios({
        url: '/api/data/wish/channel/stat',
        method: 'post',
        data
    })
}

// 获取次数限制
export const getLimitData = (data) => {
    return axios({
        url: '/api/admin/wish/user/limit/get',
        method: 'get',
        data
    })
}

// 删除次数
export const deleteLimitData = (data) => {
    return axios({
        url: '/api/admin/wish/user/limit',
        method: 'delete',
        data
    })
}

// 导出用户信息
export const exportUserInfo = (data) => {
    return axios({
        url: '/api/admin/wish/user/no/pass/export',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/http/moudules/wish/user.js